import { Request, Response, NextFunction } from "express";
import { NotificationService } from "../services/notification.service";
import { jsonStatus, status } from "../../../utils/helpers/api.responses";
import Container from "typedi";

export class NotificationController {
    private notificationService = Container.get(NotificationService);

    public createNotification = async (req: Request, res: Response, next: NextFunction) => {
        try {
            const t = req.t
            const result = await this.notificationService.createNotification(t, req.body);
            return res.status(201).json(result);
        } catch (error) {
            next(error);
        }
    };

    public getNotifications = async (req: Request, res: Response, next: NextFunction) => {
        try {
            const t = req.t
            const userId = req.user._id;
            const {
                page = 1,
                limit = 50,
                search = "",
            } = req.query;

            const result = await this.notificationService.getUserNotifications(t,
                userId,
                parseInt(page as string),
                parseInt(limit as string),
                search as string,
            );

            return res.status(status.OK).json({
                status: jsonStatus.OK,
                message: t("General.get_success", { field: t("Notification.notification") }),
                ...result,
            });
        } catch (error) {
            next(error);
        }
    };

    public markAsRead = async (req: Request, res: Response, next: NextFunction) => {
        try {
            const t = req.t
            const { notificationId } = req.params;
            const notification = await this.notificationService.markAsRead(t, notificationId);
            if (!notification) {
                return res.status(404).json({ error: req.t("Notification.not_found") });
            }
            res.json(notification);
        } catch (error) {
            next(error);
        }
    };

    public markAsUnread = async (req: Request, res: Response, next: NextFunction) => {
        try {
            const t = req.t
            const { notificationId } = req.params;
            const notification = await this.notificationService.markAsUnread(t, notificationId);
            if (!notification) {
                return res.status(404).json({ error: req.t("Notification.not_found") });
            }
            res.json(notification);
        } catch (error) {
            next(error);
        }
    };

    public deleteNotifications = async (req: Request, res: Response, next: NextFunction) => {
        try {
            const t = req.t
            const { userId } = req.params;
            const ids: string[] = req.body.ids;

            if (!Array.isArray(ids) || !userId) {
                return res.status(400).json({ message: req.t("General.invalid_input") });
            }

            const result = await this.notificationService.deleteNotifications(t, ids, userId);

            return res.status(status.OK).json({
                message: t("General.delete_success", { field: t("Notification.notification") }),
                ...result
            });
        } catch (error) {
            next(error);
        }
    };

    public deleteAllNotifications = async (req: Request, res: Response, next: NextFunction) => {
        try {
            const t = req.t
            const userId = req.user._id;
            const result = await this.notificationService.deleteAllNotifications(t, userId);

            return res.status(status.OK).json({
                message: t("General.delete_success", { field: t("Notification.notification") }),
                ...result
            });
        } catch (error) {
            next(error);
        }
    };
}
